import * as dm from "deepmerge";
const { all: deepmerge } = { ...dm }.default || dm;
function isObject(value) {
  return !!value && typeof value === "object" && !Array.isArray(value);
}
function mergeDeep(obj1, obj2) {
  return deepmerge([obj1, obj2], {
    arrayMerge: (_, source) => source
  });
}
function mergeRight(value1, value2) {
  if (isObject(value1) && isObject(value2)) {
    return mergeDeep(value1, value2);
  }
  return typeof value2 === "undefined" ? value1 : value2;
}
export {
  mergeRight
};
//# sourceMappingURL=merge.js.map
